// Framework and third-party non-UI
import React from 'react';

// Redux, contexts, and local helpers/utils/modules

// Component specific modules (Component-styled, etc.)

// App components

// Third-party components (buttons, icons, etc.)
import { CalciteSelect } from '@esri/calcite-components-react';

export interface CalciteSelectWrapperProps
  extends Omit<
    React.ComponentProps<typeof CalciteSelect>,
    'value' | 'onChange'
  > {
  value: string | number | boolean | null;
  onChange: (value: string | number | boolean) => void;
}

const CalciteSelectWrapper = ({
  disabled,
  value,
  onChange,
  ...rest
}: CalciteSelectWrapperProps) => {
  const onCalciteSelectChange = (e: any) => onChange(e.target.value);

  return (
    <CalciteSelect
      disabled={disabled || undefined}
      value={String(value) ?? undefined}
      onCalciteSelectChange={onCalciteSelectChange}
      {...rest}
    />
  );
};

export default CalciteSelectWrapper;
